<template>
    <button @click="$emit('click')"
            :class="`button${ type ? ' ' + type + '-btn' : '' }${ size ? ' ' + size + '-btn' : '' }${ icon ? ' ' + icon  + '-icon' : '' }${ loading ? ' loading' : '' }`"
            :type="elType ? elType : 'button'"
            :disabled="loading">
        <slot></slot>
        <i v-if="loading" class="loader"></i>
    </button>
</template>

<script>
export default {
    name: "Button",
    props: [
        "type",
        "size",
        "icon",
        "elType",
        "loading"
    ]
}
</script>
